export enum Level {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
  QUATERNARY = "QUATERNARY",
}

export enum Size {
  XSMALL = "XSMALL",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  XLARGE = "XLARGE",
  XXLARGE = "XXLARGE",
  XXXLARGE = "XXXLARGE",
}

export enum IconAlignment {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum CheckStyle {
  SQUARE = "SQUARE",
  DISK = "DISK",
}
